import axios from 'axios';

import { toIsoString } from '../viva/utils';
import { Flow } from '../viva/constants';

import type { AddTokenRequest } from '../viva/types/payments';
import type {
  Shift4AccessTokenResponse,
  Shift4ErrorResponse,
  TokenizedCardResponse,
} from '../viva/types/response';
import type { AddTokenBody } from '@tishman/shift4fetch';
import type { I4GoChdErrorResponse, I4GoChdResponse } from './types';

/**
 * Backend Token request - to avoid CORS >:(
 */
export const tokenizeCard = async (chd: AddTokenRequest) => {
  const dateTime = toIsoString(new Date());
  const body: AddTokenBody = {
    ...chd,
    card: {
      ...chd.card,
      securityCode: {
        indicator: '1',
        value: chd.card.securityCode,
      },
    },
    dateTime,
  };

  return new Promise<TokenizedCardResponse | Shift4ErrorResponse>((resolve) => {
    const response = axios
      .post('/api/shift4/cards/tokenize', body)
      .then((response) => response.data)
      .catch((error) => {
        console.log('ERROR', error);
      });
    resolve(response);
  });
};

export const accessToken = async () => {
  return new Promise<Shift4AccessTokenResponse | Shift4ErrorResponse>(
    (resolve) => {
      const response = axios
        .post('/api/shift4/access')
        .then((response) => response.data)
        .catch((error) => error);
      resolve(response);
    },
  );
};

interface I4GoChd {
  i4go_cardnumber: string;
  i4go_cardtype: string;
  i4go_clientIP: string;
  i4go_cvv2code: string;
  i4go_expirationmonth: string;
  i4go_expirationyear: string;
  i4go_postalcode?: string;
  i4go_streetaddress?: string;
  i4go_cardholdername: string;
  flow: Flow;
  correlationId?: string;
}

export const i4Go = async (req: I4GoChd) => {
  return new Promise<I4GoChdResponse | I4GoChdErrorResponse>((resolve) => {
    return axios
      .post<I4GoChdResponse | I4GoChdErrorResponse>(
        '/api/shift4/i4go/tokenize',
        req,
      )
      .then(({ data }) => resolve(data))
      .catch((error) => {
        console.error('i4go error', error);
        throw error;
      });
  });
};
